import { AfterViewInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { IotaTabComponent } from './iota-tab/iota-tab.component';

@Component({
    standalone: false,
    selector: 'app-iota-tabs',
    template: ` <ng-container>
        <div class="tabs">
            <div class="w-full border-b border-iota-outline">
                <ng-content select="app-iota-tab"></ng-content>
            </div>
        </div>
        <div class="w-full overflow-hidden flex relative">
            <ng-content select="app-iota-tab-content"></ng-content>
        </div>
    </ng-container>`
})
export class IotaTabsComponent implements AfterViewInit {
    @Input() activeTab!: any;

    @Output() activeTabChange = new EventEmitter<any>();

    @ContentChildren(IotaTabComponent) tabs!: QueryList<IotaTabComponent>;

    ngAfterViewInit() {
        this.tabs.forEach((tab) =>
            tab.tabActivated.subscribe((it) => {
                this.activeTabChange.emit(it);
            })
        );
    }
}
